<h1>STAGE E TIROCINI</h1>
<p>
	Un modo per raggiungere gli obiettivi della De Cifris è stimolare
	una collaborazione tra studenti e aziende/enti tramite stage e tirocini.
	Nel concreto, si intende aiutare:
</p>
<ul>
	<li> Gli studenti a trovare enti/aziende che li possano ospitare. </li>
	<li> Le aziende/enti a trovare candidati validi.</li>
</ul>
<p>
	Il Coordinatore di questa attività è il prof. Massimo Giulietti (UNIPG).
</p>

<h2>COME CANDIDARSI</h2>
<p>Ogni studente iscritto alla De Cifris può candidarsi direttamente attraverso la pagina
	<a href="https://www.linkedin.com/in/de-componendis-cifris-iniziativa-nazionale-8274501a5/">
		LinkedIn De Cifris</a>, oppure scrivendo a <a href="mailto:segreteria@decifris.it">
		segreteria&#64;decifris.it</a> e in CC al prof. Giulietti <a href="massimo.giulietti@unipg.it">
		massimo.giulietti&#64;unipg.it</a>.
</p>
<p>
	Le aziende o gli enti interessati a stagisti/tirocinanti/collaboratori in crittografia sono pregati di
	contattare la segreteria dell'associazione. Il loro avviso sarà pubblicato sulla
	pagina LinkedIn dedicata.
</p>